export default {
      id: "mask_compo-usage",
      viewBox: "0 0 100 400",
      url: "../dist/images/" + "sprite.svg#mask_compo-usage",
      toString: function () {
        return this.url;
      }
    }